

import React, { useState, useRef, useEffect } from "react";
import { Card, Table, Form, Row, Col, Dropdown } from "react-bootstrap";
import { FiFileText, FiDownload } from "react-icons/fi";
import ResumeViewModal from "../../components/modals/recruitment/ResumeViewModal";
import ResumeParsingHeader from "../../components/recruitment/ResumeParsingHeader";

import { FiCalendar, FiChevronDown } from "react-icons/fi";
const initialData = [
  {
    id: "Cand-003",
    name: "John Harris",
    img: "/assets/img/users/user-05.jpg",
    role: "Technician",
    phone: "(196) 2348 947",
    exp: "5 yrs",
    location: "Chicago",
    email: "john@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-004",
    name: "Carole Langan",
    img: "/assets/img/users/user-03.jpg",
    role: "Web Developer",
    phone: "(138) 6487 295",
    exp: "1 yr",
    location: "Houston",
    email: "carole@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-005",
    name: "Charles Marks",
    img: "/assets/img/users/user-02.jpg",
    role: "Sales Executive Officer",
    phone: "(154) 6485 218",
    exp: "4 yrs",
    location: "Phoenix",
    email: "charles@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-006",
    name: "Kerry Drake",
    img: "/assets/img/users/user-04.jpg",
    role: "Designer",
    phone: "(185) 5947 097",
    exp: "2 yrs",
    location: "Dallas",
    email: "kerry@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-007",
    name: "David Carmona",
    img: "/assets/img/users/user-06.jpg",
    role: "Account Manager",
    phone: "(106) 3485 978",
    exp: "3 yrs",
    location: "Austin",
    email: "david@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-008",
    name: "Margaret Soto",
    img: "/assets/img/users/user-07.jpg",
    role: "SEO Analyst",
    phone: "(174) 3795 107",
    exp: "5 yrs",
    location: "Boston",
    email: "margaret@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-009",
    name: "Jeffrey Thaler",
    img: "/assets/img/users/user-08.jpg",
    role: "Admin",
    phone: "(128) 0975 348",
    exp: "4 yrs",
    location: "Miami",
    email: "jeffrey@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-010",
    name: "Rebecca Smith",
    img: "/assets/img/users/user-09.jpg",
    role: "HR Executive",
    phone: "(143) 6574 222",
    exp: "6 yrs",
    location: "Seattle",
    email: "rebecca@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-011",
    name: "Daniel Carter",
    img: "/assets/img/users/user-10.jpg",
    role: "Backend Developer",
    phone: "(189) 9988 123",
    exp: "3 yrs",
    location: "San Diego",
    email: "daniel@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-012",
    name: "Olivia Brown",
    img: "/assets/img/users/user-11.jpg",
    role: "UI/UX Designer",
    phone: "(162) 8877 555",
    exp: "2 yrs",
    location: "New York",
    email: "olivia@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-013",
    name: "James Anderson",
    img: "/assets/img/users/user-12.jpg",
    role: "Project Manager",
    phone: "(155) 7766 333",
    exp: "8 yrs",
    location: "Los Angeles",
    email: "james@example.com",
    resume: "/assets/resume/sample.pdf",
  },
  {
    id: "Cand-014",
    name: "Sophia Wilson",
    img: "/assets/img/users/user-13.jpg",
    role: "QA Engineer",
    phone: "(177) 6655 111",
    exp: "4 yrs",
    location: "Denver",
    email: "sophia@example.com",
    resume: "/assets/resume/sample.pdf",
  },
];

export default function ResumeParsingPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const filtered = data
    .filter((d) =>
      d.name.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file;
    link.download = "resume.pdf";
    link.click();
  };
  const [designation, setDesignation] = useState("Designation");
  const [sort, setSort] = useState("Sort By : Last 7 Days");
 const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };

  // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };

  return (
    <div  style={{ padding: "15px", background: "#f8f9fa",  }} >

<ResumeParsingHeader/>
     <Card style={{ borderRadius: "5px" }}>
      {/* HEADER */}
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          background: "#ffffff",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>Resume List</h5>
 <div
      style={{
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      {/* DATE INPUT */}
  <div ref={containerRef} style={{ position: "relative", width: 250 }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* MOBILE */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>


      {/* DESIGNATION DROPDOWN */}
      <Dropdown>
        <Dropdown.Toggle
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            fontSize: "14px",
            color: "#111",
            display: "flex",
            alignItems: "center",
            minWidth: "150px",
          }}
        >
          {designation}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            borderRadius: "10px",
            padding: "8px 0",
            minWidth: "180px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
            border: "1px solid #eee",
          }}
        >
          {["Accountant", "Developer", "Designer", "Manager"].map((item) => (
            <Dropdown.Item
              key={item}
              onClick={() => setDesignation(item)}
              style={{
                padding: "8px 15px",
                fontSize: "14px",
              }}
            >
              {item}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* SORT DROPDOWN */}
      <Dropdown>
        <Dropdown.Toggle
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            fontSize: "14px",
            color: "#111",
            display: "flex",
            alignItems: "center",
            minWidth: "190px",
          }}
        >
          {sort}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            borderRadius: "10px",
            padding: "8px 0",
            minWidth: "180px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
            border: "1px solid #eee",
          }}
        >
          {[
            "Today",
            "Last 7 Days",
            "Last 30 Days",
            "This Year",
          ].map((item) => (
            <Dropdown.Item
              key={item}
              onClick={() => setSort(`Sort By : ${item}`)}
              style={{
                padding: "8px 15px",
                fontSize: "14px",
              }}
            >
              {item}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
      </Card.Header>

      <Card.Body>
        {/* FILTER */}
        <Row className="mb-3">
          <Col md={6}>
            Row Per Page{" "}
            <Form.Select
              value={rows}
              onChange={(e) => setRows(Number(e.target.value))}
              style={{ width: 80, display: "inline-block" }}
            >
              <option>5</option>
              <option>10</option>
              <option>20</option>
            </Form.Select>{" "}
            Entries
          </Col>

          <Col md={6} className="text-md-end">
            <Form.Control
              placeholder="Search"
              style={{ maxWidth: 250, display: "inline-block" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead style={{ background: "#f8fafc" }}>
              <tr>
                <th><Form.Check /></th>
                <th>Cand ID</th>
                <th>Candidate</th>
                <th>Applied Role</th>
                <th>Phone</th>
                <th>Experience</th>
                <th>Location</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item, i) => (
                <tr key={i}>
                  <td><Form.Check /></td>
                  <td>{item.id}</td>

                  {/* USER */}
                  <td>
                    <div style={flexRow}>
                      <img src={item.img} style={avatar} />
                      <div>
                        <div>{item.name}</div>
                        <small>{item.email}</small>
                      </div>
                    </div>
                  </td>

                  <td>{item.role}</td>
                  <td>{item.phone}</td>
                  <td>{item.exp}</td>
                  <td>{item.location}</td>

                  {/* STATUS */}
                  <td>
                    <span style={statusBadge}>
                      ● Parsed
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td>
                    <div style={{ display: "flex", gap: 12 }}>
                      <FiFileText
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowModal(true);
                        }}
                      />

                      <FiDownload
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDownload(item.resume)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>

      {/* MODAL */}
      <ResumeViewModal
        show={showModal}
        onHide={() => setShowModal(false)}
        data={selected}
      />
    </Card>
    </div>
  );
}

/* STYLES */
const flexRow = { display: "flex", gap: 10, alignItems: "center" };
const avatar = { width: 40, height: 40, borderRadius: "50%" };
const statusBadge = {
  border: "1px solid #3b82f6",
  color: "#3b82f6",
  padding: "3px 10px",
  borderRadius: 6,
  fontSize: 12,
};
const btnStyle = {
  background: "#fff",
  border: "1px solid #ddd",
  fontSize: 13,
};
const inputStyle = {
  border: "1px solid #ddd",
  borderRadius: 6,
  padding: "6px 10px",
};